import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data/content";

export const MarqueeStrip = () => (
  <div data-testid="marquee-strip" className="bg-[#16281D] py-6 overflow-hidden">
    <Marquee speed={20} gradient={false} autoFill>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center text-[#F8F7F4]/90 text-sm uppercase tracking-[0.25em] font-medium">
          <span className="mx-8">{item}</span>
          <span className="text-[#B85C38] text-lg">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
